import React, { useContext, useEffect, useRef } from 'react';

import { AnimatePresence } from 'framer-motion';
import { gsap } from 'gsap';
import { ThemeContext } from 'styled-components';

import { useMediaQuery } from '@pkg/providers';

import {
    ContentWrapper,
    DraggableBar,
    InnerWrapper,
    ItemEditMobileOverlay,
    OuterWrapper,
} from '@app/pages/Prototype/Grid/ItemEditMobile/styles';

interface MobileInputEditCardProps {
    open: boolean;
    background?: string;
    children?: React.ReactElement;
    onClose: () => void;
    forceBottom?: boolean;
}

export function MobileInputEditCard({
    open = false,
    children,
    background,
    onClose,
    forceBottom,
}: MobileInputEditCardProps) {
    const theme = useContext(ThemeContext);
    const { usingMouse } = useMediaQuery();

    const outerWrapperRef = useRef<HTMLDivElement>(null);
    const innerWrapperRef = useRef<HTMLDivElement>(null);
    const spacerRef = useRef<HTMLDivElement>(null);

    const sharedTransition = {
        duration: theme.transitions.speeds.normal,
        ease: theme.transitions.eases.cubic,
    };
    // Create overlay spacer so that any content at bottom of screen is pushed up and not hidden by overlay
    useEffect(() => {
        if (!spacerRef.current || !outerWrapperRef.current) return;
        gsap.set(spacerRef.current, { height: outerWrapperRef.current.clientHeight });
    }, []);

    return (
        <AnimatePresence>
            {open && !usingMouse && (
                <>
                    <div ref={spacerRef} />
                    <ItemEditMobileOverlay onClick={onClose} />
                    <OuterWrapper $forceBottom={forceBottom}>
                        <InnerWrapper
                            $customBackground={background}
                            ref={innerWrapperRef}
                            initial={{ y: '100%' }}
                            animate={{ y: 0 }}
                            exit={{ y: '100%' }}
                            transition={sharedTransition}
                        >
                            <DraggableBar onPointerDown={onClose} />
                            <AnimatePresence mode="wait" initial={false}>
                                <ContentWrapper
                                    key="mobile-edit-input"
                                    initial={{ x: '100%' }}
                                    animate={{ x: 0 }}
                                    exit={{ x: '100%' }}
                                    transition={sharedTransition}
                                >
                                    {children}
                                </ContentWrapper>
                            </AnimatePresence>
                        </InnerWrapper>
                    </OuterWrapper>
                </>
            )}
        </AnimatePresence>
    );
}
